// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/enums/gig/badge.proto" (package "bianka.enums.gig", syntax proto3)
// tslint:disable
/**
 * @generated from protobuf enum bianka.enums.gig.Badge
 */
export enum Badge {
    /**
     * @generated from protobuf enum value: BADGE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: BADGE_BUY_IT_AGAIN = 1;
     */
    BUY_IT_AGAIN = 1,
    /**
     * @generated from protobuf enum value: BADGE_FEATURED = 2;
     */
    FEATURED = 2,
    /**
     * @generated from protobuf enum value: BADGE_FIVERR_CHOICE = 3;
     */
    FIVERR_CHOICE = 3,
    /**
     * @generated from protobuf enum value: BADGE_NEW_ARRIVAL = 4;
     */
    NEW_ARRIVAL = 4,
    /**
     * @generated from protobuf enum value: BADGE_PRO = 5;
     */
    PRO = 5,
    /**
     * @generated from protobuf enum value: BADGE_STUDIO = 6;
     */
    STUDIO = 6,
    /**
     * @generated from protobuf enum value: BADGE_PROMOTED_GIG = 7;
     */
    PROMOTED_GIG = 7,
    /**
     * @generated from protobuf enum value: BADGE_RISING_TALENT = 8;
     */
    RISING_TALENT = 8,
    /**
     * @generated from protobuf enum value: BADGE_SELLER_COUNTRY_FLAG = 9;
     */
    SELLER_COUNTRY_FLAG = 9,
    /**
     * @generated from protobuf enum value: BADGE_VETTED = 10;
     */
    VETTED = 10,
    /**
     * @generated from protobuf enum value: BADGE_PRO_VETTED = 11;
     */
    PRO_VETTED = 11,
    /**
     * @generated from protobuf enum value: BADGE_OFFER_CONSULTATION = 12;
     */
    OFFER_CONSULTATION = 12,
    /**
     * @generated from protobuf enum value: BADGE_SELLER_LEVEL_NO_LEVEL = 13;
     */
    SELLER_LEVEL_NO_LEVEL = 13,
    /**
     * @generated from protobuf enum value: BADGE_SELLER_LEVEL_ONE = 14;
     */
    SELLER_LEVEL_ONE = 14,
    /**
     * @generated from protobuf enum value: BADGE_SELLER_LEVEL_TWO = 15;
     */
    SELLER_LEVEL_TWO = 15,
    /**
     * @generated from protobuf enum value: BADGE_SELLER_LEVEL_TOP_RATED = 16;
     */
    SELLER_LEVEL_TOP_RATED = 16,
    /**
     * @generated from protobuf enum value: BADGE_AI_DELIVERY = 17;
     */
    AI_DELIVERY = 17
}
